/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    GetPressKitDocumentDetailResponse,
    GetPressKitDocumentDetailResponseFromJSON,
    GetPressKitDocumentDetailResponseToJSON,
    GetPressKitDocumentListResponse,
    GetPressKitDocumentListResponseFromJSON,
    GetPressKitDocumentListResponseToJSON,
    GetPressKitGuideLinesResponse,
    GetPressKitGuideLinesResponseFromJSON,
    GetPressKitGuideLinesResponseToJSON,
    GetPressKitImageDetailResponse,
    GetPressKitImageDetailResponseFromJSON,
    GetPressKitImageDetailResponseToJSON,
    GetPressKitImageListResponse,
    GetPressKitImageListResponseFromJSON,
    GetPressKitImageListResponseToJSON,
    GetPressKitLogoDetailResponse,
    GetPressKitLogoDetailResponseFromJSON,
    GetPressKitLogoDetailResponseToJSON,
    GetPressKitLogoListResponse,
    GetPressKitLogoListResponseFromJSON,
    GetPressKitLogoListResponseToJSON,
    GetPressKitProfileDetailResponse,
    GetPressKitProfileDetailResponseFromJSON,
    GetPressKitProfileDetailResponseToJSON,
    GetPressKitProfilesListResponse,
    GetPressKitProfilesListResponseFromJSON,
    GetPressKitProfilesListResponseToJSON,
    GetPressKitTagListResponse,
    GetPressKitTagListResponseFromJSON,
    GetPressKitTagListResponseToJSON,
    ModelError,
    ModelErrorFromJSON,
    ModelErrorToJSON,
    PostPressKitBatchDownloadRequestBody,
    PostPressKitBatchDownloadRequestBodyFromJSON,
    PostPressKitBatchDownloadRequestBodyToJSON,
    PostPressKitBatchDownloadResponse,
    PostPressKitBatchDownloadResponseFromJSON,
    PostPressKitBatchDownloadResponseToJSON,
} from '../models';

export interface GetPressKitCompaniesCompanyIdDocumentsRequest {
    companyId: number;
}

export interface GetPressKitCompaniesCompanyIdDocumentsDocumentIdRequest {
    companyId: number;
    documentId: string;
}

export interface GetPressKitCompaniesCompanyIdGuidelinesRequest {
    companyId: number;
}

export interface GetPressKitCompaniesCompanyIdImagesRequest {
    companyId: number;
}

export interface GetPressKitCompaniesCompanyIdLogosRequest {
    companyId: number;
}

export interface GetPressKitCompaniesCompanyIdLogosImageIdRequest {
    companyId: number;
    imageId: string;
}

export interface GetPressKitCompaniesCompanyIdLogosLogoIdRequest {
    companyId: number;
    logoId: string;
}

export interface GetPressKitCompaniesCompanyIdProfilesRequest {
    companyId: number;
}

export interface GetPressKitCompaniesCompanyIdProfilesProfileIdRequest {
    companyId: number;
    profileId: string;
}

export interface GetPressKitCompaniesCompanyIdTagsRequest {
    companyId: number;
}

export interface PostPressKitCompaniesCompanyIdBatchDownloadRequest {
    companyId: number;
    postPressKitBatchDownloadRequestBody?: PostPressKitBatchDownloadRequestBody;
}

/**
 * 
 */
export class PressKitApi extends runtime.BaseAPI {

    /**
     * プレスキットの資料一覧を取得するAPI
     * Get PressKit Document List
     */
    async getPressKitCompaniesCompanyIdDocumentsRaw(requestParameters: GetPressKitCompaniesCompanyIdDocumentsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPressKitDocumentListResponse>> {
        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling getPressKitCompaniesCompanyIdDocuments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_kit/companies/{company_id}/documents`.replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPressKitDocumentListResponseFromJSON(jsonValue));
    }

    /**
     * プレスキットの資料一覧を取得するAPI
     * Get PressKit Document List
     */
    async getPressKitCompaniesCompanyIdDocuments(requestParameters: GetPressKitCompaniesCompanyIdDocumentsRequest, initOverrides?: RequestInit): Promise<GetPressKitDocumentListResponse> {
        const response = await this.getPressKitCompaniesCompanyIdDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスキットの資料の詳細を取得するAPI
     * Get PressKit Document Detail
     */
    async getPressKitCompaniesCompanyIdDocumentsDocumentIdRaw(requestParameters: GetPressKitCompaniesCompanyIdDocumentsDocumentIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPressKitDocumentDetailResponse>> {
        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling getPressKitCompaniesCompanyIdDocumentsDocumentId.');
        }

        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling getPressKitCompaniesCompanyIdDocumentsDocumentId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_kit/companies/{company_id}/documents/{document_id}`.replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))).replace(`{${"document_id"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPressKitDocumentDetailResponseFromJSON(jsonValue));
    }

    /**
     * プレスキットの資料の詳細を取得するAPI
     * Get PressKit Document Detail
     */
    async getPressKitCompaniesCompanyIdDocumentsDocumentId(requestParameters: GetPressKitCompaniesCompanyIdDocumentsDocumentIdRequest, initOverrides?: RequestInit): Promise<GetPressKitDocumentDetailResponse> {
        const response = await this.getPressKitCompaniesCompanyIdDocumentsDocumentIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスキットのガイドラインを提供するAPI
     * Get PressKit GuideLines
     */
    async getPressKitCompaniesCompanyIdGuidelinesRaw(requestParameters: GetPressKitCompaniesCompanyIdGuidelinesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPressKitGuideLinesResponse>> {
        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling getPressKitCompaniesCompanyIdGuidelines.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_kit/companies/{company_id}/guidelines`.replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPressKitGuideLinesResponseFromJSON(jsonValue));
    }

    /**
     * プレスキットのガイドラインを提供するAPI
     * Get PressKit GuideLines
     */
    async getPressKitCompaniesCompanyIdGuidelines(requestParameters: GetPressKitCompaniesCompanyIdGuidelinesRequest, initOverrides?: RequestInit): Promise<GetPressKitGuideLinesResponse> {
        const response = await this.getPressKitCompaniesCompanyIdGuidelinesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスキットの画像一覧を取得するAPI
     * Get PressKit Image List
     */
    async getPressKitCompaniesCompanyIdImagesRaw(requestParameters: GetPressKitCompaniesCompanyIdImagesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPressKitImageListResponse>> {
        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling getPressKitCompaniesCompanyIdImages.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_kit/companies/{company_id}/images`.replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPressKitImageListResponseFromJSON(jsonValue));
    }

    /**
     * プレスキットの画像一覧を取得するAPI
     * Get PressKit Image List
     */
    async getPressKitCompaniesCompanyIdImages(requestParameters: GetPressKitCompaniesCompanyIdImagesRequest, initOverrides?: RequestInit): Promise<GetPressKitImageListResponse> {
        const response = await this.getPressKitCompaniesCompanyIdImagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスキットのロゴ一覧を取得するAPI
     * Get PressKit Logo List
     */
    async getPressKitCompaniesCompanyIdLogosRaw(requestParameters: GetPressKitCompaniesCompanyIdLogosRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPressKitLogoListResponse>> {
        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling getPressKitCompaniesCompanyIdLogos.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_kit/companies/{company_id}/logos`.replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPressKitLogoListResponseFromJSON(jsonValue));
    }

    /**
     * プレスキットのロゴ一覧を取得するAPI
     * Get PressKit Logo List
     */
    async getPressKitCompaniesCompanyIdLogos(requestParameters: GetPressKitCompaniesCompanyIdLogosRequest, initOverrides?: RequestInit): Promise<GetPressKitLogoListResponse> {
        const response = await this.getPressKitCompaniesCompanyIdLogosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスキットの画像の詳細を取得するAPI
     * Get PressKit Image Detail
     */
    async getPressKitCompaniesCompanyIdLogosImageIdRaw(requestParameters: GetPressKitCompaniesCompanyIdLogosImageIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPressKitImageDetailResponse>> {
        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling getPressKitCompaniesCompanyIdLogosImageId.');
        }

        if (requestParameters.imageId === null || requestParameters.imageId === undefined) {
            throw new runtime.RequiredError('imageId','Required parameter requestParameters.imageId was null or undefined when calling getPressKitCompaniesCompanyIdLogosImageId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_kit/companies/{company_id}/images/{image_id}`.replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))).replace(`{${"image_id"}}`, encodeURIComponent(String(requestParameters.imageId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPressKitImageDetailResponseFromJSON(jsonValue));
    }

    /**
     * プレスキットの画像の詳細を取得するAPI
     * Get PressKit Image Detail
     */
    async getPressKitCompaniesCompanyIdLogosImageId(requestParameters: GetPressKitCompaniesCompanyIdLogosImageIdRequest, initOverrides?: RequestInit): Promise<GetPressKitImageDetailResponse> {
        const response = await this.getPressKitCompaniesCompanyIdLogosImageIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスキットのロゴの詳細を取得するAPI
     * Get PressKit Logo Detail
     */
    async getPressKitCompaniesCompanyIdLogosLogoIdRaw(requestParameters: GetPressKitCompaniesCompanyIdLogosLogoIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPressKitLogoDetailResponse>> {
        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling getPressKitCompaniesCompanyIdLogosLogoId.');
        }

        if (requestParameters.logoId === null || requestParameters.logoId === undefined) {
            throw new runtime.RequiredError('logoId','Required parameter requestParameters.logoId was null or undefined when calling getPressKitCompaniesCompanyIdLogosLogoId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_kit/companies/{company_id}/logos/{logo_id}`.replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))).replace(`{${"logo_id"}}`, encodeURIComponent(String(requestParameters.logoId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPressKitLogoDetailResponseFromJSON(jsonValue));
    }

    /**
     * プレスキットのロゴの詳細を取得するAPI
     * Get PressKit Logo Detail
     */
    async getPressKitCompaniesCompanyIdLogosLogoId(requestParameters: GetPressKitCompaniesCompanyIdLogosLogoIdRequest, initOverrides?: RequestInit): Promise<GetPressKitLogoDetailResponse> {
        const response = await this.getPressKitCompaniesCompanyIdLogosLogoIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスキットのプロフィール一覧を取得するAPI
     * Get PressKit Profiles
     */
    async getPressKitCompaniesCompanyIdProfilesRaw(requestParameters: GetPressKitCompaniesCompanyIdProfilesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPressKitProfilesListResponse>> {
        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling getPressKitCompaniesCompanyIdProfiles.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_kit/companies/{company_id}/profiles`.replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPressKitProfilesListResponseFromJSON(jsonValue));
    }

    /**
     * プレスキットのプロフィール一覧を取得するAPI
     * Get PressKit Profiles
     */
    async getPressKitCompaniesCompanyIdProfiles(requestParameters: GetPressKitCompaniesCompanyIdProfilesRequest, initOverrides?: RequestInit): Promise<GetPressKitProfilesListResponse> {
        const response = await this.getPressKitCompaniesCompanyIdProfilesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスキットのプロフィールの詳細を取得するAPI
     * Get PressKit profile Detail
     */
    async getPressKitCompaniesCompanyIdProfilesProfileIdRaw(requestParameters: GetPressKitCompaniesCompanyIdProfilesProfileIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPressKitProfileDetailResponse>> {
        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling getPressKitCompaniesCompanyIdProfilesProfileId.');
        }

        if (requestParameters.profileId === null || requestParameters.profileId === undefined) {
            throw new runtime.RequiredError('profileId','Required parameter requestParameters.profileId was null or undefined when calling getPressKitCompaniesCompanyIdProfilesProfileId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_kit/companies/{company_id}/profiles/{profile_id}`.replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))).replace(`{${"profile_id"}}`, encodeURIComponent(String(requestParameters.profileId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPressKitProfileDetailResponseFromJSON(jsonValue));
    }

    /**
     * プレスキットのプロフィールの詳細を取得するAPI
     * Get PressKit profile Detail
     */
    async getPressKitCompaniesCompanyIdProfilesProfileId(requestParameters: GetPressKitCompaniesCompanyIdProfilesProfileIdRequest, initOverrides?: RequestInit): Promise<GetPressKitProfileDetailResponse> {
        const response = await this.getPressKitCompaniesCompanyIdProfilesProfileIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスキットのタグ一覧を取得するAPI
     * Get PressKit Tags API
     */
    async getPressKitCompaniesCompanyIdTagsRaw(requestParameters: GetPressKitCompaniesCompanyIdTagsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<GetPressKitTagListResponse>> {
        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling getPressKitCompaniesCompanyIdTags.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/press_kit/companies/{company_id}/tags`.replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPressKitTagListResponseFromJSON(jsonValue));
    }

    /**
     * プレスキットのタグ一覧を取得するAPI
     * Get PressKit Tags API
     */
    async getPressKitCompaniesCompanyIdTags(requestParameters: GetPressKitCompaniesCompanyIdTagsRequest, initOverrides?: RequestInit): Promise<GetPressKitTagListResponse> {
        const response = await this.getPressKitCompaniesCompanyIdTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * プレスキットの一括ダウンロードを開始するAPI
     * Post PressKit Batch Download
     */
    async postPressKitCompaniesCompanyIdBatchDownloadRaw(requestParameters: PostPressKitCompaniesCompanyIdBatchDownloadRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PostPressKitBatchDownloadResponse>> {
        if (requestParameters.companyId === null || requestParameters.companyId === undefined) {
            throw new runtime.RequiredError('companyId','Required parameter requestParameters.companyId was null or undefined when calling postPressKitCompaniesCompanyIdBatchDownload.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/press_kit/companies/{company_id}/batch_download`.replace(`{${"company_id"}}`, encodeURIComponent(String(requestParameters.companyId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostPressKitBatchDownloadRequestBodyToJSON(requestParameters.postPressKitBatchDownloadRequestBody),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostPressKitBatchDownloadResponseFromJSON(jsonValue));
    }

    /**
     * プレスキットの一括ダウンロードを開始するAPI
     * Post PressKit Batch Download
     */
    async postPressKitCompaniesCompanyIdBatchDownload(requestParameters: PostPressKitCompaniesCompanyIdBatchDownloadRequest, initOverrides?: RequestInit): Promise<PostPressKitBatchDownloadResponse> {
        const response = await this.postPressKitCompaniesCompanyIdBatchDownloadRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
